module.exports = __webpack_public_path__ + "img/1.56c6f3f1.png";